<app-flat-layout-wrapper>
  <router-outlet></router-outlet>
</app-flat-layout-wrapper>
